import { api } from '../../lib/api'
import { reactLocalStorage } from 'reactjs-localstorage';

export const IMPERSONATE_REQUEST = 'IMPERSONATE_REQUEST'
export const IMPERSONATE_SUCCESS = 'IMPERSONATE_SUCCESS'
export const IMPERSONATE_FAILED = 'IMPERSONATE_FAILED'
export const IMPERSONATE_END_CLEAR = 'IMPERSONATE_END_CLEAR'

export const impersonate = function (merchantId) {
  return function (dispatch) {
    dispatch({
      type: IMPERSONATE_REQUEST
    })
    api.impersonate(merchantId).then(impersonateResponse => {
      reactLocalStorage.clear()
      dispatch({
        type: IMPERSONATE_SUCCESS,
        payload: impersonateResponse
      })
    }).catch(error => {
      dispatch({
        type: IMPERSONATE_FAILED,
        error
      })
    })
  }
}
export const clearImpersonateEnd = () => {
  return (dispatch) => {
    dispatch({
      type: IMPERSONATE_END_CLEAR
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/impersonate.js